var GenericView = require('views/generic.view.ts');
var _ = require("underscore");
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/consumption.template.html');

var MonthlyView = require('views/consumption/monthly.consumption.view.ts');
var YearlyView = require('views/consumption/yearly.consumption.view.ts');
var CustomizedView = require('views/consumption/customized.consumption.view.ts');

var TheView = GenericView.extend({
    el: '#consumption',
    tagName: '',
	template: Handlebars.compile(Template),
	fields: [],
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "consumption");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);
        this.renderTabsContent();
    },
    events: {
        "input .to-validation input": "validateIt",
        "change select.select-type-energy": "showProperSelection",
        "click #collapseDescription": "collapseDescription"
    },
    validateIt: _.debounce(
        function(event)
        {
            var element = $(event.currentTarget);
            this.validateSingleField(element);
        },
    300),
    showProperSelection: function(event) {
        var selectionValue = $(event.currentTarget).val();

        this.$el.find(".ui-tabview__panels > .show").removeClass("show").removeClass("to-validation");
        var id = selectionValue;
        $("#" + id).addClass("show").addClass("to-validation");
    },
     renderTabsContent: function() {
         var monthly_view = new MonthlyView();
         var yearly_view = new YearlyView();
         var customized_view = new CustomizedView();
     },
     collapseDescription: function(event) {
         var btn = event.currentTarget;
         GenericView.prototype.collapseDescription(btn);
     },
});

module.exports= TheView;